import numeral from 'numeral'

function format (value, formatType) {
    return numeral(value).format(formatType)
}

function parse (value) {
    return numeral(value).value()
}

// Register filter on Vue instance
function install (Vue) {
    Vue.filter('numeral', format)
    Vue.prototype.$formatNumeral = format
}

export default {
    format,
    parse,
    install
}
